import apiClient from "@/api/client";
import type {
  Announcement,
  AnnouncementAudience,
  AnnouncementFormData,
  AnnouncementStatus,
  LoginChanges,
} from "../types";

const wrap = <T>(promise: Promise<{ data: { data: T } }>) =>
  promise.then((r) => r.data.data);

export const whatsNewApi = {
  list: (status?: AnnouncementStatus) =>
    wrap<Announcement[]>(
      apiClient.get("/announcements/", { params: status ? { status } : {} }),
    ),

  create: (data: AnnouncementFormData) =>
    wrap<Announcement>(apiClient.post("/announcements/", data)),

  update: (id: string, data: Partial<AnnouncementFormData>) =>
    wrap<Announcement>(apiClient.patch(`/announcements/${id}/`, data)),

  remove: (id: string) => apiClient.delete(`/announcements/${id}/`),

  publish: (id: string, isImportant = false) =>
    wrap<Announcement>(
      apiClient.post(`/announcements/${id}/publish/`, { is_important: isImportant }),
    ),

  markRead: (id: string) =>
    wrap<{ is_read: boolean }>(apiClient.post(`/announcements/${id}/mark-read/`)),

  audience: (id: string) =>
    wrap<AnnouncementAudience>(apiClient.get(`/announcements/${id}/audience/`)),

  unreadCount: () =>
    wrap<{ count: number }>(apiClient.get("/announcements/unread-count/")),

  loginChanges: () =>
    wrap<LoginChanges>(apiClient.get("/announcements/login-changes/")),

  confirmLoginChanges: () =>
    wrap<{ confirmed: boolean }>(
      apiClient.post("/announcements/login-changes/confirm/"),
    ),
};
